import * as aiAssistantService from '../../services/AiAssistant/aiAssistantService';
import {createDialogActions} from '../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: () => aiAssistantService.setAiAgentFeedback      ,
  },
});


